import React, {useState} from 'react';
import i18next from 'i18next';
import CheckboxSwitch from './CheckboxSwitch';
import '../styles/campaignCover.css';
import ConfirmModal from './ConfirmModal';
import CampaignCoverPicker from './CampaignCoverPicker';

const CampaignSettings = (props) => {
  const {campaign} = props;
  const [confirmArchiveOpen, setConfirmArchiveOpen] = useState(false);
  return (
    <div className='settingsCampaign'>
      {/* <h3>{i18next.t('settings campaign')}</h3> */}
      <CampaignCoverPicker campaign={campaign} update={props.update} />
      <CheckboxSwitch
        isChecked={campaign.hideValueCharacterStatsOnChat}
        label={i18next.t('campaignSettings.hide character stat value on chat')}
        update={(value) => {
          const newData = {...campaign}
          newData.hideValueCharacterStatsOnChat = value;
          props.update(newData);
        }}
      />
      <CheckboxSwitch
        isChecked={campaign.renameCharacter}
        label={i18next.t('campaignSettings.rename character')}
        update={(value) => {
          const newData = {...campaign}
          newData.renameCharacter = value;
          props.update(newData);
        }}
      />
      <CheckboxSwitch
        isChecked={campaign.clickStat}
        label={i18next.t('campaignSettings.click to roll')}
        update={(value) => {
          const newData = {...campaign}
          newData.clickStat = value;
          props.update(newData);
        }}
      />
      <CheckboxSwitch
        isChecked={campaign.playerCanSeeAllCards}
        label={i18next.t('campaignSettings.playerCanSeeCards')}
        update={(value) => {
          const newData = {...campaign}
          if(value === false ) {
            newData.playerCanUpdateCardsUsed = false;
          }
          newData.playerCanSeeAllCards = value;
          props.update(newData);
        }}
      />
      <CheckboxSwitch
        disabled={!campaign.playerCanSeeAllCards}
        isChecked={campaign.playerCanUpdateCardsUsed}
        label={i18next.t('campaignSettings.playerCanEditCards')}
        update={(value) => {
          const newData = {...campaign}
          newData.playerCanUpdateCardsUsed = value;
          props.update(newData);
        }}
      />
      <button
        className='danger'
        onClick={(e) => {
          setConfirmArchiveOpen(true);
          e.preventDefault();
        }}
      >
        {i18next.t('archive.campaign')}
      </button>
      <ConfirmModal
        isOpen={confirmArchiveOpen}
        message={i18next.t('archive.campaign-validation')}
        onConfirm={() => {
          const newData = {...campaign};
          newData.active = false;
          props.update(newData);
          setConfirmArchiveOpen(false);
        }}
        onCancel={() => setConfirmArchiveOpen(false)}
      />
    </div>
  );
  
}

export default CampaignSettings